import gql from "graphql-tag";

export const GET_SERVICE_PROVIDER_BY_ID = gql`
query getServiceProviderById($id: uuid!){
  ServiceProviders(where: { id: {_eq: $id}}){
    id
    serviceCategoryId 
    companyName
    personName
    image
    mobile
    whatsappNumber
    city
    state
    experience
    isChargeable
    createdBy
  }
}`